import React from "react";
import TextField from "@mui/material/TextField";
import MenuItem from "@mui/material/MenuItem";

interface SelectFieldProps {
  name: string;
  value: string | number;
  label: string;
  onChange: (event: React.ChangeEvent<HTMLInputElement>) => void;
  error?: string;
  classes?: { input?: string; textField?: string };
  options: { value: string; label: string }[];
}

function SelectField({
  name,
  value,
  label,
  onChange,
  error,
  classes,
  options = [],
}: SelectFieldProps) {
  return (
    <TextField
      select
      fullWidth
      required
      variant="outlined"
      name={name}
      label={label}
      value={value}
      onChange={onChange}
      helperText={error}
      error={!!error}
      sx={{ bgcolor: 'background.paper' }}
    >
      {options.map((option: { value: string; label: string }) => (
        <MenuItem key={option.value} value={option.value}>
          {option.label}
        </MenuItem>
      ))}
    </TextField>
  );
}

export default SelectField;
